import { Navigate, Outlet } from 'react-router-dom';

/** Redirects to patient login when no patient JWT is stored. */
export default function RequirePatientToken() {
  const token = localStorage.getItem('patient_token');
  if (!token) {
    return <Navigate to="/patient-loyalty/login" replace />;
  }
  return <Outlet />;
}
